<template>
<div>
  <div>
    <span
      class="pointer"
      v-for="(route, index) in routeBack"
      v-bind:key="index"
      v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
      v-on:click="goBack(route, index)">
     <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
    </span>
    <hr>
    <v-btn :disabled="uploadDisabled || !$online || ( mpoints1.length == 0 && mpoints2.length == 0 && mpoints3.length == 0 && mpoints4.length == 0 && mpoints5.length == 0 && mpoints6.length == 0)" flat icon color="grey" id="graphbutton" title="Temperatur-Logs hochladen" v-on:click="upload">
        <v-icon color="green" size="50">cloud_upload</v-icon>
    </v-btn>
    <br>
    <h5>
    Marktnummer: 8045 -
    Rewe Markt Dagli

    </h5>
  </div>
    <div class="alert alert-warning" v-if="!$online && ( mpoints1.length > 0 || mpoints2.length > 0 || mpoints3.length > 0 || mpoints4.length > 0 || mpoints5.length > 0|| mpoints6.length > 0 )">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Internetverbindung benötigt um Daten hochzuladen!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <div class="alert alert-success" v-if="showSuccess">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification"><v-icon size="30">close</v-icon></button>
      <span><center>
          <v-icon color="green" size="25">check</v-icon>
        <b>Die Temperatur Logs wurden mit der Datenbank synchronisiert!</b>
        </center>
      </span>
    </div>
    <div class="alert alert-danger" id="Alarm" v-if="showAlarm">
      <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification"><v-icon size="30">close</v-icon></button>
      <span><center>
          <v-icon size="25">error</v-icon>
        <b>Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!</b>
        </center>
      </span>
    </div>
    
    <br>
        <div class="row">
            
            <div class="col-xs-12 col-md-12 col-xl-6" v-for="bereich in bereiche" v-bind:key="bereich.bereichsnummer" v-on:click="gotoBereich(bereich.bereichsnummer, bereich.title, bereich.maxTemp)">
                    <div class="card" id="bereiche">
                        <div class="card-header" id="header">
                            <h5 class="card-title" id="title">
                                {{bereich.title}}
                                <v-chip v-if="bereich.newDataSets"
                                id="graphbutton"
                                >
                                {{bereich.newDataSets}}
                <v-icon right color="green" v-if="$online">cloud_upload</v-icon>
                <v-icon right v-else>cloud_upload</v-icon>
                                    </v-chip>
                            </h5>
                            <p class="card-category tablecard" id="subtitle">{{bereich.subtitle}}</p>
                        </div> 
                    </div>
            </div>  
        </div>       
    </div> 
</template>

<script>
import navigation from "../../../store/navigation"

export default {
    data() {
        return {
            auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
            routeBack: [],
            bereiche: [
                {
                    bereichsnummer: 1,
                    title: "Service-Theke",
                    subtitle: "Bereich 1",
                    newDataSets: 0
                },
                {
                    bereichsnummer: 2,
                    title: "MoPro",
                    subtitle: "Bereich 2",
                    newDataSets: 0
                },
                {
                    bereichsnummer: 3,
                    title: "Tiefkühl",
                    subtitle: "Bereich 3",
                    newDataSets: 0
                },
                {
                    bereichsnummer: 4,
                    title: "Obst",
                    subtitle: "Bereich 4",
                    newDataSets: 0
                },
                {
                    bereichsnummer: 5,
                    title: "Warenannahme",
                    subtitle: "Bereich 5",
                    newDataSets: 0
                },
                {
                    bereichsnummer: 6,
                    title: "Getränkemarkt",
                    subtitle: "Bereich 6",
                    newDataSets: 0
                }
            ],
            mpoints1: [],
            mpoints2: [],
            mpoints3: [],
            mpoints4: [],
            mpoints5: [],
            mpoints6: [],
            showAlarm: false,
            showSuccess: false,
            uploadDisabled: false
        }
    },
    mounted() {
        if (localStorage.getItem("mpoints" + this.bereiche[0].bereichsnummer)) {
            try {
                this.mpoints1 = JSON.parse(localStorage.getItem("mpoints" + this.bereiche[0].bereichsnummer))
                this.bereiche[0].newDataSets = this.mpoints1.length
            } catch (e) {
                localStorage.removeItem("mpoints" + this.bereiche[0].bereichsnummer)
            }
        }
        if (localStorage.getItem("mpoints" + this.bereiche[1].bereichsnummer)) {
            try {
                this.mpoints2 = JSON.parse(localStorage.getItem("mpoints" + this.bereiche[1].bereichsnummer))
                this.bereiche[1].newDataSets = this.mpoints2.length
            } catch (e) {
                localStorage.removeItem("mpoints" + this.bereiche[1].bereichsnummer)
            }
        }
        if (localStorage.getItem("mpoints" + this.bereiche[2].bereichsnummer)) {
            try {
                this.mpoints3 = JSON.parse(localStorage.getItem("mpoints" + this.bereiche[2].bereichsnummer))
                this.bereiche[2].newDataSets = this.mpoints3.length
            } catch (e) {
                localStorage.removeItem("mpoints" + this.bereiche[2].bereichsnummer)
            }
        }
        if (localStorage.getItem("mpoints" + this.bereiche[3].bereichsnummer)) {
            try {
                this.mpoints4 = JSON.parse(localStorage.getItem("mpoints" + this.bereiche[3].bereichsnummer))
                this.bereiche[3].newDataSets = this.mpoints4.length
            } catch (e) {
                localStorage.removeItem("mpoints" + this.bereiche[3].bereichsnummer)
            }
        }
        if (localStorage.getItem("mpoints" + this.bereiche[4].bereichsnummer)) {
            try {
                this.mpoints5 = JSON.parse(localStorage.getItem("mpoints" + this.bereiche[4].bereichsnummer))
                this.bereiche[4].newDataSets = this.mpoints5.length
            } catch (e) {
                localStorage.removeItem("mpoints" + this.bereiche[4].bereichsnummer)
            }
        }
        if (localStorage.getItem("mpoints" + this.bereiche[5].bereichsnummer)) {
            try {
                this.mpoints5 = JSON.parse(localStorage.getItem("mpoints" + this.bereiche[5].bereichsnummer))
                this.bereiche[4].newDataSets = this.mpoints6.length
            } catch (e) {
                localStorage.removeItem("mpoints" + this.bereiche[5].bereichsnummer)
            }
        }
    },
    computed: {},
    methods: {
        goBack(route, index) {
            if (route !== "temperaturen") {
                this.$router.push({ path: navigation.createNav(route).path })
            }
        },
        disableNotification() {
            this.showAlarm = false
            this.showSuccess = false
        },
        gotoBereich(id, title, maxTemp) {
            console.log(id)
            // this.$router.push("/temperaturen/" + id);
            this.$router.push({
                path: "temperaturen/" + id,
                query: { title: title }
            })
        },
        upload() {
            // var mpoints1 = this.mpoints1.map( Object.values );
            this.uploadDisabled = true
            Array.prototype.push.apply(this.mpoints1, this.mpoints2)
            Array.prototype.push.apply(this.mpoints1, this.mpoints3)
            Array.prototype.push.apply(this.mpoints1, this.mpoints4)
            Array.prototype.push.apply(this.mpoints1, this.mpoints5)
            Array.prototype.push.apply(this.mpoints1, this.mpoints6)
            console.log(this.mpoints1)
            let mpointsWithoutOrder = this.mpoints1.map(({ stelle, ...item }) => item)
            var tempLogs = mpointsWithoutOrder.map(Object.values)
            console.log(tempLogs)
            let tempLogObject = {
                tempLogs: tempLogs
            }

            // this.$http.post(process.env.VUE_APP_NODE_API_URL+'/heimspiel/templogs/insertmany', tempLogObject)
            // .then(response => { console.log(response.data); })
            // .catch(e => { console.log(e); })

            this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/templogs/insertmany", tempLogObject, { headers: { Authorization: this.auth } }).then(function(response) {
                console.log(JSON.stringify(response))
                if (response.body.error) {
                    console.log(response.body.error)
                    this.showAlarm = true
                    // localStorage.clear();
                } else {
                    console.log("eingetragen")
                    this.showSuccess = true
                    localStorage.clear()
                    this.mpoints1 = []
                    this.mpoints2 = []
                    this.mpoints3 = []
                    this.mpoints4 = []
                    this.mpoints5 = []
                    this.mpoints6 = []
                    this.bereiche[0].newDataSets = 0
                    this.bereiche[1].newDataSets = 0
                    this.bereiche[2].newDataSets = 0
                    this.bereiche[3].newDataSets = 0
                    this.bereiche[4].newDataSets = 0
                    this.bereiche[5].newDataSets = 0
                }
                // this.addBestellung(response.body.data.id, response.body.data.organizer.email, date, reihenterminId);
                // this.addRechnung()
            })
        }
    },

    created: function() {
        this.routeBack = navigation.createNav("temperaturen").params
    },
    updated: function() {},

    components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#frame {
    margin-left: 0%;
    margin-top: 0%;
    padding-left: 0%;
    padding-top: 0%;
    padding-right: 0%;
}
#bereiche:hover {
    cursor: pointer;
}
#subtitle {
    padding-left: 6px;
}
.pointer {
    cursor: default;
}
.backBar:hover {
    cursor: pointer;
    text-decoration: underline;
    color: red;
}
.Alarm {
    color: white;
}
</style>
